import { Injectable, signal } from '@angular/core';
import { Theme } from 'web-reader-lib';

@Injectable({ providedIn: 'root' })
export class ReaderThemeCacheService {
  // key: `${prefix ?? ''}|${passId}`
  private cache = new Map<string, Theme>();

  set(prefix: string | null, passId: string, theme: Theme | undefined | null) {
    if (!theme) return;
    this.cache.set(this.key(prefix, passId), theme);
    sessionStorage.setItem(this.key(prefix, passId), JSON.stringify(theme));
  }

  get(prefix: string | null, passId: string): Theme | null {
    const k = this.key(prefix, passId);
    const mem = this.cache.get(k);
    if (mem) return mem;

    const raw = sessionStorage.getItem(k);
    if (!raw) return null;
    try {
      const t = JSON.parse(raw) as Theme;
      this.cache.set(k, t);
      return t;
    } catch {
      return null;
    }
  }

  private key(prefix: string | null, passId: string) {
    return `wr-theme|${prefix ?? ''}|${passId}`;
  }
}